(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-ignore-modified-result.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-ignore-modified-result.js');
"use strict";


const {
  useLocation
} = ReactRouterDOM;
const {
  PARAM_IGNORE_MODIFIED_RESULT
} = svs.components.sport.tipsenShared;
const useIgnoreModifiedResults = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const ignoreModifiedResult = params.has(PARAM_IGNORE_MODIFIED_RESULT);
  return ignoreModifiedResult;
};
setGlobal('svs.components.poolBetting.hooks.useIgnoreModifiedResults', useIgnoreModifiedResults);

 })(window);